<div [ngStyle]="
      {
        'background-color':  active ? circleColor : 'gray',
        'width': width,
        'height': height
      }"
     class="circle">
  <img *ngIf="!showInitials" src="{{photoUrl}}">

  <div *ngIf="showInitials" class="initials">
    {{ initials }}
  </div>
</div>
